import { ToastMessage } from '@cokitchen/cokitchen-components';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';

const VerifyEmail = () => {
  const token = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    verifyEmail();
  }, []);
  const verifyEmail = async () => {
    try {
      const res = await apiService.post(`auth/confirm-email`, {
        data: token
      });
      if (res) {
        toast(<ToastMessage type='success' message='Your email has been updated successfully' />);
        localStorage.clear();
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      navigate('/');
    }
  };
  return <div />;
};

export default VerifyEmail;
